import { render, staticRenderFns } from "./HeaderAddress.vue?vue&type=template&id=694ef91d&scoped=true&"
import script from "./HeaderAddress.vue?vue&type=script&lang=js&"
export * from "./HeaderAddress.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAddress.vue?vue&type=style&index=0&id=694ef91d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694ef91d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('694ef91d', component.options)
    } else {
      api.reload('694ef91d', component.options)
    }
    module.hot.accept("./HeaderAddress.vue?vue&type=template&id=694ef91d&scoped=true&", function () {
      api.rerender('694ef91d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/common_components/header/HeaderAddress.vue"
export default component.exports